import { cx } from 'class-variance-authority';
import { getImageProps } from 'next/image';
import { useTranslations } from 'next-intl';

import Image from '@/app/components/Image';
import Motion from '@/app/components/Motion';
import useJapaneseRegionalSite from '@/app/experiments/useJapaneseRegionalSite';

import MobileFeature from './MobileFeature';

const TakeAWalk = () => {
  const t = useTranslations();

  const isJapaneseRegionalSite = useJapaneseRegionalSite();

  const mainImage = isJapaneseRegionalSite
    ? 'ja-regional/hp-features-taking-a-walk-desktop'
    : 'home/oreo/hand-holding-bag';

  const mainImgAlt = isJapaneseRegionalSite
    ? 'woman_shoe_img_alt'
    : 'hand_holding_bag_alt';

  const { props: heartRateMaskImageProps } = getImageProps({
    alt: '',
    height: 350,
    src: `blue-sky/home/take-walk-mask-2.jpg`,
    width: 223,
  });

  const { props: activityGoalsMaskImageProps } = getImageProps({
    alt: '',
    height: 275,
    src: `blue-sky/home/take-walk-mask-3.jpg`,
    width: 300,
  });

  const { props: mobileMaskImageProps } = getImageProps({
    alt: '',
    height: 277,
    src: `blue-sky/home/take-walk-mask-mobile.jpg`,
    width: 300,
  });

  return (
    <MobileFeature
      title="features_tab_2_label"
      image={{ alt: mainImgAlt, src: mainImage }}
    >
      <div className="relative hidden lg:block" data-cy="take-a-walk">
        <div className="hidden grid-cols-1 grid-rows-1 justify-items-end lg:grid">
          <Image
            alt=""
            src="blue-sky/home/take-walk-mask-1"
            height={81}
            width={340}
            className="col-start-1 col-end-2 row-start-1 row-end-2 my-6 rounded-lg"
          />
          <Image
            localizedAlt="stretch_legs_image_alt"
            localizedSrc="stretch_legs_notification"
            format="png"
            height={81}
            width={340}
            className="col-start-1 col-end-2 row-start-1 row-end-2 my-6 rounded-lg"
          />
        </div>
        <Image
          alt={t(mainImgAlt)}
          src={mainImage}
          height={510}
          width={605}
          className="rounded-lg object-cover"
          data-cy="take-a-walk-image"
        />
      </div>
      <div
        className={cx(
          'absolute bottom-16 left-1/2 w-[80vw] max-w-[300px] -translate-x-1/2 flex-col gap-y-6',
          'lg:relative lg:bottom-auto lg:left-0 lg:flex lg:w-auto lg:max-w-none lg:translate-x-0',
        )}
      >
        <div
          className="hidden grid-cols-1 grid-rows-1 overflow-hidden rounded-lg bg-cover lg:grid"
          style={{ backgroundImage: `url(${heartRateMaskImageProps.src})` }}
        >
          <Image
            localizedAlt="heart_rate_image_2_alt"
            className="col-start-1 col-end-2 row-start-1 row-end-2"
            localizedSrc="home_scenarios_walk_hr_ui"
            format="png"
            width={350}
            height={223}
            data-cy="walk-heart-rate-app-ui-image"
          />
        </div>
        <div
          className="hidden w-fit grid-cols-1 grid-rows-1 overflow-hidden rounded-lg bg-cover lg:grid"
          style={{ backgroundImage: `url(${activityGoalsMaskImageProps.src})` }}
        >
          <Image
            localizedAlt="activity_goal_image_alt"
            className="col-start-1 col-end-2 row-start-1 row-end-2"
            localizedSrc="home_scenarios_walk_steps_ui"
            format="png"
            width={300}
            height={275}
            data-cy="walk-steps-app-ui-image"
          />
        </div>
        <Motion
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, type: 'tween', delay: 0.5 }}
          className="grid grid-cols-1 grid-rows-1 overflow-hidden rounded-lg bg-cover lg:hidden"
          style={{ backgroundImage: `url(${mobileMaskImageProps.src})` }}
        >
          <Image
            localizedAlt="activity_goal_image_alt"
            className="col-start-1 col-end-2 row-start-1 row-end-2"
            localizedSrc="home_scenarios_walk_steps_ui"
            format="png"
            width={300}
            height={277}
            data-cy="walk-steps-app-ui-image"
          />
        </Motion>
      </div>
    </MobileFeature>
  );
};

export default TakeAWalk;
